import { EmptyValue } from "@bcc/components/ui";
import { formatDate } from "@client-shared/utils";
import type { PurchaseOrderInvoice } from "@shared/types/payout";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const InvoiceDueDateCell = (props: CellContext<PurchaseOrderInvoice, unknown>) => {
  const { t } = useTranslation();
  const invoiceStatus = props.row.original.invoiceStatus;
  const payDate = props.row.original.lastSettleDate;
  const dueDate = props.row.original.dueDate;

  // Don't show dates for Unposted invoices
  if (invoiceStatus === "Unposted") {
    return (
      <div className="text-sm leading-snug">
        <EmptyValue />
      </div>
    );
  }

  return (
    <div className="text-sm leading-snug">
      {payDate && (
        <div className="text-gray-500">
          <span>{t("components.invoiceDetailDrawer.labels.paid")}</span>
          <span className="ml-1">{formatDate(payDate)}</span>
        </div>
      )}

      <div className="text-gray-900">
        <span>{t("components.invoiceDetailDrawer.labels.due")}</span>
        <span className="ml-1">{formatDate(dueDate)}</span>
      </div>
    </div>
  );
};
